import React from "react";
import SidebarContent from "./SidebarContent";

function Sidebar() {
	return (
		<SidebarContent />
	);
};

export default Sidebar